// extracted by mini-css-extract-plugin
module.exports = {"work_area":"style_work_area__2zliA"};